import axiosClient from '@app/services/axios';
import {getSaveResult} from "@app/utils/helpers";

export const uploadService = {
	postUpload,
	getListStandard,
	ImportStandard,
	uploadFileDisplay,
	excelPath,
	excelInit,
	getUploadMTPhasing_ListStandard,
	templateMTPhasingPath
};

async function uploadFileDisplay(file,param) {
	let formData = new FormData();

	formData.append('fileUpload', file);
	//console.log(param);
	if(param )
	{
		Object.keys(param).forEach(key => {
			formData.append(key, param[key]);
		});
	}

	/*
	formData.append('custId', param.custId);
	formData.append('programType', param.programType);
	formData.append('latGPS', param.latGPS);
	formData.append('longGPS', param.longGPS);
	formData.append('custLatGPS', param.custLatGPS);
	formData.append('custLongGPS', param.custLongGPS);*/

	//formData.append('uploadType', uploadType);
	const res = await axiosClient
		.post(`uploadFileDisplay`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		})
		.then((responde) => {
			return responde.data;
		})
		.catch((error) => {
			return null;
		});
	return res;
}
async function postUpload(file,uploadType) {
	let formData = new FormData();

	formData.append('fileUpload', file);
	if(uploadType && uploadType != null && uploadType.length > 0)
		formData.append('uploadType', uploadType);
	const res = await axiosClient
		.post(`uploadFile`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		})
		.then((responde) => {
			return responde.data;
		})
		.catch((error) => {
			return null;
		});
	return res;
}

function templateMTPhasingPath(params) {
    return getSaveResult(axiosClient.post(`templateMTPhasingPath`, params));
}

async function ImportStandard(formData) {



		const res = await axiosClient
		.post(`ImportStandard`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		})
		.then((responde, request) => {
			
			return responde.data;
		})
		.catch((error) => {
			return null;
		});
	console.log(res);	
	return res;
}

async function excelInit(controller) {



	const v = await axiosClient
		.get(`excelInit/${controller}`)
		.then((responde) => {
			console.log(responde);
			return responde.data.data;
		})

		.catch((error) => {
			console.log(error);
			return {};
		});
	return v;

}

async function excelPath(params) {

	return getSaveResult(axiosClient.post(`excelPath`, params));
}

function getListStandard(paramFilter) {
	const v = axiosClient
		.post(
			'Upload_ListStandard',
			paramFilter
		)
		.then((responde) => {
			return responde.data.data;
		})
		.catch((error) => {
			return null;
		});
	return v;
}

function getUploadMTPhasing_ListStandard(paramFilter) {
	const v = axiosClient
		.post(
			'UploadMTPhasing_ListStandard',
			paramFilter
		)
		.then((responde) => {
			return responde.data.data;
		})
		.catch((error) => {
			return null;
		});
	return v;
}
